/**
 * Created by Ning Jiang on 11/17/2016.
 */

import ("pixi.js");

declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";

window.PIXI = PIXI;
require ("pixi-spine");

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {WildNudge} from "./game/WildNudge";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {WildNudgePromoPanelConfig} from "./game/WildNudgePromoPanelConfig";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {WildNudgeIntroConfig} from "./game/intro/WildNudgeIntroConfig";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}

window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new WildNudge(),
    new SlotKeypad(),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new WildNudgePromoPanelConfig()),
    new NolimitGameIntroPlugin(new WildNudgeIntroConfig())
]);
// (<NolimitAudioPlayer>SlotGame.sound).showLogs(true);